/**
 * 提供 SSO 必要的 Vendor DSM 色彩對照。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 新增 Vendor Button/Normal DSM 對照模組
 * @external https://innotech.atlassian.net/browse/IN-144499 - 供 Passkey 連接密鑰按鈕套用 DSM Button/Normal
 */

/**
 * 對應 fluid-two 各業主 v4Primary 的 Button/Normal 色彩。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 建立業主 Button/Normal 色彩對照表
 */
export const BUTTON_NORMAL_COLOR_BY_VENDOR = {
  vd001: '#4C9EEA',
  vd002: '#0865FE',
  vd003: '#B79153',
  vd004: '#4C9EEA',
  vd006: '#FFBA00',
  vd007: '#000000',
  vd008: '#00B2B5',
  vd009: '#FF2741',
  vd010: '#FFBA00',
  vd011: '#009440',
  vd012: '#A4E0F5',
  vd013: '#FF7E07',
  vd014: '#036242',
  vd015: '#FFBA00',
  vd016: '#98C135',
  vd086: '#FFBA00',
  vd087: '#FFBA00',
  vd088: '#FFBA00',
  vd089: '#FFBA00',
  vd099: '#FFBA00',
} as const;

/**
 * Button/Normal 對照表支援的業主代號聯集。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 提供業主代號型別約束
 */
export type ButtonNormalVendorId = keyof typeof BUTTON_NORMAL_COLOR_BY_VENDOR;

/**
 * 未知業主時的 Button/Normal fallback 代號（對齊 fluid-two vd099）。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 設定未知業主 fallback 為 vd099
 */
const BUTTON_NORMAL_FALLBACK_VENDOR_ID: ButtonNormalVendorId = 'vd099';

/**
 * 判斷字串是否為已知的 Button/Normal 業主代號。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 提供業主代號型別守衛
 */
const isButtonNormalVendorId = (vendorId: string): vendorId is ButtonNormalVendorId =>
  Object.prototype.hasOwnProperty.call(BUTTON_NORMAL_COLOR_BY_VENDOR, vendorId);

/**
 * 將業主代號正規化後取得 Button/Normal 色彩，未知業主依 fluid-two 規則使用 vd099。
 * @external https://innotech.atlassian.net/browse/IN-144602 - 新增依業主代號解析 Button/Normal 色彩
 * @external https://innotech.atlassian.net/browse/IN-144499 - 供 SSO Passkey 按鈕套用業主色
 */
export const getButtonNormalColor = (vendorId?: string | null): string => {
  const normalizedVendorId = vendorId?.trim().toLowerCase();

  if (normalizedVendorId && isButtonNormalVendorId(normalizedVendorId)) {
    return BUTTON_NORMAL_COLOR_BY_VENDOR[normalizedVendorId];
  }

  return BUTTON_NORMAL_COLOR_BY_VENDOR[BUTTON_NORMAL_FALLBACK_VENDOR_ID];
};
